module.exports = __webpack_public_path__ + "static/media/manOnTable.52be3144.svg";